// const Mock = require('mockjs')

const paymentMock = () => {
  const paymentList = [{
    contractNum: '5001818878',
    paymentNum: '001000217749',
    referenceNum: '000000000005',
    paymentAccount: '31621545216590102',
    accountType: 'MOP',
    paymentAmount: '340',
    paymentState: 1,
    paymentTime: '2020-08-25 19:24:26',
    billTime: '2020-07',
    payer: 'ZHANGSAN'
  },
  {
    contractNum: '5001818839',
    paymentNum: '001000217772',
    referenceNum: '000000000011',
    paymentAccount: '31621545216554048',
    accountType: 'MOP',
    paymentAmount: '720.13',
    paymentState: 1,
    paymentTime: '2020-08-27 15:24:17',
    billTime: '2020-07',
    payer: 'WANGWU'
  },
  {
    contractNum: '5001818728',
    paymentNum: '001000217965',
    referenceNum: '000000000052',
    paymentAccount: '31621545216579298',
    accountType: 'MOP',
    paymentAmount: '735',
    paymentState: 0,
    paymentTime: '2020-08-29 22:15:07',
    billTime: '2020-07',
    payer: 'LISI'
  }
  ]

  return {
    data: paymentList
  }
}

export default {
  path: '/paymentMock.do',
  method: 'get',
  mock: paymentMock
}
